module.exports = __webpack_public_path__ + "img/white_emblem.d2deaad6.png";